import { Form, Formik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, FormGroup, Input, Modal, ModalBody, Row } from "reactstrap";
import { setConfirmCloseStaffSessionModalOpen } from "../../redux/actions/staffSession/staffSessionAction";

export const ConfirmCloseStaffSession = ({ handleSubmit }) => {
  const dispatch = useDispatch();
  const { confirmCloseStaffSessionModalOpen } = useSelector((state) => state.staffSession);

  const toggle = () => {
    dispatch(setConfirmCloseStaffSessionModalOpen(!confirmCloseStaffSessionModalOpen));
  };

  return (
    <section>
      <Modal
        isOpen={confirmCloseStaffSessionModalOpen}
        toggle={toggle}
        centered={true}
        size="lg"
        className="large-pop delete-pop"
      >
        <ModalBody>
          <div className="modal-body-content">
            <Formik
              initialValues={{
                cashOnSiteConfirmed: "",
              }}
              onSubmit={handleSubmit}
            >
              {({ errors, values, touched, setFieldValue }) => {
                return (
                  <Form className="admin-details">
                    <div className="content">
                      <div className="delete-title">
                        <h2 className="">Cash On Site Confirmation is Required</h2>
                      </div>
                      <div className="delete-data">
                        <h4>
                          Please fill in your confirmation about cash on site at close session
                        </h4>
                      </div>
                      <div className="pb-4">
                        <Row className="justify-content-center">
                          <Col md={9}>
                            <FormGroup className="custom-inputs mb-md-0">
                              <Input
                                type="number"
                                name="cashOnSiteConfirmed"
                                id="cashOnSiteConfirmed"
                                placeholder="Cash On Site.."
                                onChange={(e) =>
                                  setFieldValue("cashOnSiteConfirmed", e.target.value)
                                }
                                required
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="action-btn-block pt-2">
                      <button
                        className={`btn btn-small btn-transparent`}
                        type="button"
                        onClick={toggle}
                      >
                        {/* {!props.disabled ? props.value : } */}
                        {"Cancel"}
                      </button>
                      <button className={`btn btn-small btn-grey`} type="submit">
                        {"Confirm"}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
    </section>
  );
};
